var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 9.50004L2.0625 14.8125C2.0625 16.5729 3.48959 18 5.24998 18L15.8749 18C17.6354 18 19.0624 16.5729 19.0624 14.8125L19.0624 4.18757C19.0624 2.42713 17.6354 1.00009 15.8749 1.00009L10.5624 1.00009",
    stroke: "#0A2933",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.65611L7.37496 3.65611M7.37496 3.65611L4.71873 6.31235M7.37496 3.65611L4.71873 0.999882",
    stroke: "#0A2933",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.8f899e7103e7cd0014e1c2953fa4fbef.svg";
export { ForwardRef as ReactComponent };